export default __webpack_public_path__ + "static/assets/af6c5e7043dd84000c545c7f424a573e.gif";